<template>
    <div :class="withTypes ? 'grid grid-cols-1 gap-8' : 'grid grid-cols-2 gap-16 mb-16'">
        <select-dropdown
            static-id="publicationLanguageDropdown"
            :disabled="!job"
            :input-label="$t('campaigns.editor.details.language')"
            :options="availableLanguages"
            :placeholder="!!job ? $t('campaigns.editor.details.language') : $t('campaigns.editor.details.language_disabled')"
            v-if="!withTypes"
            v-model="form.locale"
        />

        <template v-for="(filter, key) in filters">
            <select-dropdown
                :static-id="key.replace('_', '') + 'Dropdown'"
                :auto-translate="false"
                :input-label="$t('campaigns.' + filter.translationField) + (filter.required ? ' *' : '')"
                :key="key"
                :multiple="filter.multiple"
                :options="key === 'educations' ? translatedEducations : filter.data"
                :placeholder="filter.data ? $t('campaigns.' + filter.translationField) : null"
                :remove-icon="filter.multiple"
                :searchable="filter.searchable"
                v-if="key === 'job_level' && !withTypes || key === 'types' && withTypes || key !== 'job_level' && key !== 'types'"
                v-model="form[filter.model]"
                @change="update"
            />
        </template>
    </div>
</template>
<script>

import * as campaigns from "../../services/CampaignService";
import Form from "../../etc/forms/Form";
import Campaign from "../../models/Campaign";
import SelectDropdown from "../forms/SelectDropdown";
import {mapState} from "pinia";
import {useMainStore} from '../../state/store';

export default {
    components: {SelectDropdown},
    model: {
        prop: 'form',
        event: 'update'
    },
    props: {
        form: Form,
        withTypes: Boolean,
        campaign: {
            type: Campaign,
            required: false
        },
        job: Object,
    },
    data() {
        return {
            filters: {}
        }
    },
    computed: {
        ...mapState(useMainStore, ['currentCompany', 'locale']),
        availableLanguages() {
            return this.job?.active_languages.map(lang => {
                return {
                    label: `languages.${lang}.title`,
                    value: lang
                }
            }) || [];
        },
        regionLocale() {
            if (this.campaign && this.campaign.country_code)
                return this.campaign.country_code;

            if (['nl', 'be'].includes(this.form.country_code))
                return 'nl';
            else
                return 'en';
        },
        regionTranslationPath() {
            const country_code = this.campaign && this.campaign.country_code ? this.campaign.country_code : this.form.country_code;
            return 'campaigns.editor.educations' + (country_code ? '.' + country_code : '') + '.';
        },
        translatedEducations() {
            if (!this.filters.educations.data)
                return this.filters.educations.data;

            return JSON.parse(JSON.stringify(this.filters.educations.data)).map(option => {
                option.label = this.$t(`${this.regionTranslationPath}${option.label}`, this.regionLocale);
                return option;
            })
        }
    },
    methods: {
        educationSearch: campaigns.educations,
        regionSearch: campaigns.regions,
        profileSearch: campaigns.profiles,
        sectorSearch: campaigns.sectors,
        channelTypes: campaigns.channelTypes,
        update() {
            this.$emit('update', this.form);
        },
        parseData(response) {
            return response.data.map(data => ({
                label: data.name,
                value: data.id
            }))
        }
    },
    watch: {
        "form.regions"(val) {
            const id = val[0];
            if (!id)
                return this.form.country_code = null;

            const region = this.filters.regions.data.find(i => i.value == id);
            if (!region)
                return this.form.country_code = null;

            if (region.label.toLowerCase().startsWith('belgi'))
                this.form.country_code = 'be';
            else if (region.label.startsWith('Netherlands') || region.label.startsWith('Nederland'))
                this.form.country_code = 'nl';
            else
                this.form.country_code = null;
        },
        "form"() {
            this.update();
        },
        "job"() {
            if (this.job && this.job.active_languages.includes(this.locale)) {
                this.form.locale = this.locale
            } else {
                this.form.locale = this.job.active_languages[0]
            }
        }
    },
    mounted() {
        Promise.all([
            campaigns.educations(),
            campaigns.regions(),
            campaigns.profiles(),
            campaigns.sectors(),
            campaigns.channelTypes(),
            campaigns.levels()
        ]).then(([educations, regions, profiles, sectors, types, levels]) => {
            this.filters = {
                regions: {
                    data: this.parseData(regions),
                    multiple: true,
                    searchable: true,
                    required: true,
                    translationField: 'regions',
                    model: 'regions'
                },
                educations: {
                    data: this.parseData(educations),
                    multiple: true,
                    searchable: false,
                    required: true,
                    translationField: 'educations',
                    model: 'educations'
                },
                sector: {
                    data: this.parseData(sectors),
                    multiple: false,
                    searchable: true,
                    required: true,
                    translationField: 'sector',
                    model: 'sector'
                },
                job_profiles: {
                    data: this.parseData(profiles),
                    multiple: true,
                    searchable: true,
                    required: true,
                    translationField: 'job_profiles',
                    model: 'job_profiles'
                },
                types: {
                    data: this.parseData(types),
                    multiple: false,
                    searchable: false,
                    required: true,
                    translationField: 'editor.channels.channel_type',
                    model: 'type_id'
                },
                job_level: {
                    data: this.parseData(levels),
                    multiple: false,
                    searchable: false,
                    required: true,
                    translationField: 'job_level',
                    model: 'job_level'
                },
            }
        })
    }
}
</script>
